import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Menu as AntdMenu } from 'antd';
import { MenuItemProps as AntdMenuItemProps } from 'antd/lib/menu';
import Icon from '../Icon';
import theme from '../theme';

const itemPadding = '10px 12px';
const hoverStyles = `
  fill: ${theme.textColorSecondary};
  color: ${theme.textColorSecondary};
`;
const IconWrapper = styled.div``;

const StyledItem = styled(AntdMenu.Item)<{
  $hasLink?: boolean;
  $hasIcon?: boolean;
  $isAntdIcon?: boolean;
  $hoverable?: boolean;
}>`
  &&& {
    color: ${theme.menuItemColor};
    display: flex;
    align-items: center;
    padding: 0;
    border-radius: ${theme.getBorderRadius('large')};

    ${({ $hoverable }) =>
      $hoverable &&
      `
        &:hover {
          background-color: ${theme.gray3};
          > *,
          .menu-item-icon-wrapper > ${Icon} > svg {
            ${hoverStyles}
          }
        }
      `}

    .ant-dropdown-menu-title-content > * {
      padding: ${itemPadding};
      margin: 0;
      color: ${theme.menuItemColor};
      display: flex;
      align-items: center;
      ${({ $hoverable }) =>
        $hoverable &&
        `&:hover {
          ${hoverStyles}
        }`}
    }

    ${({ $hasIcon, $hoverable }) =>
      $hasIcon &&
      `
      ${IconWrapper} {
        margin-right: 10px;
        ${
          $hoverable &&
          `&:hover ${IconWrapper} > ${Icon} > svg {
          ${hoverStyles}
        }`
        }
    }`}

    ${({ $hasIcon, $isAntdIcon }) =>
      $hasIcon &&
      $isAntdIcon &&
      `
      ${IconWrapper} {
        margin-right: 0px;

    }`}
  }
`;

export interface MenuItemProps extends AntdMenuItemProps {
  to?: string;
  href?: string;
  rel?: string;
  target?: string;
  icon?: React.ReactNode;
  isAntdIcon?: boolean;
  hoverable?: boolean;
  childrenWrapperStyles?: CSSProperties;
}

const Item: React.FC<MenuItemProps> = ({
  to,
  href,
  rel,
  target,
  icon,
  isAntdIcon,
  hoverable = true,
  children,
  childrenWrapperStyles,
  ...props
}) => {
  const content = (
    <>
      <IconWrapper>{icon}</IconWrapper>
      <div style={childrenWrapperStyles}>{children}</div>
    </>
  );

  if (!to && !href) {
    return (
      <StyledItem
        {...props}
        $hasIcon={Boolean(icon)}
        $isAntdIcon={Boolean(isAntdIcon)}
        $hoverable={Boolean(hoverable)}
      >
        <div>{content}</div>
      </StyledItem>
    );
  }

  return (
    <StyledItem
      {...props}
      $hasLink={Boolean(to || href)}
      $hasIcon={Boolean(icon)}
      $isAntdIcon={Boolean(isAntdIcon)}
      $hoverable={Boolean(hoverable)}
    >
      {to ? (
        <Link to={to}>{content}</Link>
      ) : (
        <a href={href} rel={rel} target={target}>
          {content}
        </a>
      )}
    </StyledItem>
  );
};

export default styled(Item)``;
